export default {
  "comingSoon": "Coming soon",
  "update": "Update",
  "searchingLibraries": "Searching media libraries...",
  "mediaUnavailable": "Media search unavailable",
  "movie": "Movie",
  "series": "Series",
  "episode": "Episode",
  "skip": "Skip to main content",
  "maintenance": "Maintenance mode enabled.",
  "blocked": "Non-admin users are currently blocked.",
  "manageSettings": "Manage settings",
  "expandNav": "Expand navigation",
  "collapseNav": "Collapse navigation",
  "closeNav": "Close navigation",
  "openNav": "Open navigation",
  "mainNav": "Main navigation",
  "primaryNav": "Primary navigation",
  "newTab": "(opens in new tab)",
  "quickNav": "Quick navigation",
  "exitReorder": "Exit reorder",
  "reorder": "Reorder categories",
  "exitReorderMode": "Exit reorder mode",
  "unpin": "Unpin menu",
  "pin": "Pin menu",
  "noApps": "No applications installed yet",
  "orderSaved": "Category order saved",
  "orderFailed": "Failed to save category order",
  "orderReset": "Category order reset to default",
  "resetFailed": "Failed to reset category order",
  "dragCategories": "Drag categories to reorder",
  "draggable": "draggable category",
  "position": "{{category}} — position {{position}} of {{total}}",
  "resetOrder": "Reset to default order",
  "profileAvatar": "Profile avatar",
  "user": "User",
  "profileName": "Profile: {{name}}",
  "logout": "Logout",
  "theme": "Theme",
  "themeName": "Theme: {{theme}}",
  "light": "Light",
  "defaultTheme": "Default",
  "spectreTheme": "Spectre",
  "reelTheme": "Reel",
  "smokedTheme": "Smoked",
  "alerts": "Alerts",
  "unreadNotifications": "Unread notifications",
  "refresh": "Refresh",
  "markAll": "Mark all read",
  "viewNotifications": "View Notification Center",
  "searchMedia": "Search pages and media...",
  "searchPages": "Search pages...",
  "searchMediaLabel": "Search dashboard pages and media",
  "searchPagesLabel": "Search dashboard pages",
  "suggestions": "Suggestions",
  "resultsFor": "Results for “{{query}}”",
  "startTyping": "Start typing to search pages...",
  "noResultsFor": "No results found for “{{query}}”",
  "media": "Media",
  "searchingMedia": "Searching media",
  "noMedia": "No media found",
  "noResults": "No results found",
  "pageResults_one": "{{count}} page result",
  "pageResults_other": "{{count}} page results",
  "mediaResults_one": "{{count}} media result",
  "mediaResults_other": "{{count}} media results",
  "navigate": "navigate",
  "open": "open",
  "close": "close",
  "search": "Search",
  "closeSearch": "Close search",
  "loadingNotifications": "Loading notifications...",
  "emptyNotifications": "No notifications yet.",
  "notificationError": "Could not load notifications.",
  "unreadNotification": "Unread notification",
  "read": "Read",
  "unread": "Unread",
  "mark": "Mark",
  "markRead": "Mark read",
  "dismiss": "Dismiss notification",
  "retry": "Retry",
  "impersonating": "Viewing the dashboard as {{name}}.",
  "ending": "Ending...",
  "stopImpersonation": "Stop Impersonating",
  "endFailed": "Failed to end impersonation",
  "endNetwork": "Network error while ending impersonation",
  "demoActive": "Demo mode active",
  "demoMessage": "You’re viewing a live demo — changes reset every 30 minutes",
  "getQuickBox": "Get QuickBox Pro",
  "toggleSubNavigation": "Toggle {{group}} sub-navigation"
} as const;
